import { defineStore } from 'pinia';

export const useDebugStore = defineStore('debug', {
  state: () => ({
    isEnabled: false,
    isPanelOpen: false,
    enrichedCourses: [],
    isLoading: false,
    error: null,
    environment: import.meta.env.VITE_ENV_HOOK || 'prod',
    certificateSlug: '',
    isRegistering: false,
    certificateMessage: null
  }),

  actions: {
    toggle() {
      this.isPanelOpen = !this.isPanelOpen;
    },
    enable() {
      if (!this.isNonProd) return;
      this.isEnabled = true;
    },
    disable() {
      this.isEnabled = false;
      this.isPanelOpen = false;
    },
    setEnrichedCourses(courses) {
      this.enrichedCourses = courses;
    },
    setLoading(value) {
      this.isLoading = value;
    },
    setError(message) {
      this.error = message;
    },
    setCertificateSlug(slug) {
      this.certificateSlug = slug;
    },
    setRegistering(value) {
      this.isRegistering = value;
    },
    setCertificateMessage(message) {
      this.certificateMessage = message;
    }
  },

  getters: {
    isNonProd: (state) => state.environment !== 'prod',
    envColor: (state) => {
      const colors = {
        localhost: '#FFC627',
        dev: '#78BE20',
        qa: '#FF7F32',
        staging: '#00A3E0',
        prod: '#8C1D40'
      };
      return colors[state.environment] || '#747474';
    }
  }
});
